import { observer } from 'mobx-react'
import { FC, MouseEvent, useState } from 'react'

import { IconClose } from '@avantstay/backoffice-vectors'

import { formatDate } from '../../utils'
import * as S from './MultiDatePicker.styles'
import { MultiDatePickerProps } from './MultiDatePickerProps'

const sortDates = (list: Date[]) => {
  return list.sort((dateA: Date, dateB: Date) => dateA.getTime() - dateB.getTime())
}

const _MultiDatePicker: FC<MultiDatePickerProps> = ({
  onChange,
  onRemoveDate,
  selectedDates = [],
  blockedDays = [],
  firstDayOfWeek,
  legend,
  specialDays,
  minDate,
  maxDate,
  customSelectedColor,
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleCalendar = () => {
    setIsOpen(prevState => !prevState)
  }

  return (
    <S.Container>
      <S.SelectDateContainer isOpen={isOpen} onClick={toggleCalendar}>
        {sortDates(selectedDates).map(date => (
          <S.DateOption key={date.toString()}>
            {formatDate(date, 'MM/dd')}
            <S.RemoveButton
              onClick={(event: MouseEvent<HTMLButtonElement>) => {
                event.stopPropagation()
                onRemoveDate(date)
              }}
            >
              <IconClose />
            </S.RemoveButton>
          </S.DateOption>
        ))}
      </S.SelectDateContainer>
      {isOpen && (
        <S.CustomDateRange
          customSelectedColor={customSelectedColor}
          show={isOpen}
          className="multiDateRangePicker"
          rootClassName="rootMultiDateRangePicker"
          minDate={minDate}
          maxDate={maxDate}
          singleDateRange
          shouldStartEmpty
          specialDays={specialDays}
          showSingleMonthPicker
          blockedDates={blockedDays.map(date => formatDate(date))}
          onChange={date => {
            onChange(date?.startDate as Date)
          }}
          onClickOut={() => {
            setIsOpen(false)
          }}
          multiSelectedDates={selectedDates}
          firstDayOfWeek={firstDayOfWeek}
        >
          {legend?.length ? (
            <S.Root>
              {legend.map(series => {
                return (
                  <S.LegendDotCell key={series.key}>
                    <S.LegendLabel>
                      {series.color ? (
                        <S.LegendDot color={series.color} half={series.halfDot} />
                      ) : null}
                      {series.label || series.key}
                    </S.LegendLabel>
                    {series.value !== undefined ? (
                      <S.LegendValue>{series.value}</S.LegendValue>
                    ) : null}
                  </S.LegendDotCell>
                )
              })}
            </S.Root>
          ) : null}
        </S.CustomDateRange>
      )}
    </S.Container>
  )
}

export const MultiDatePicker = observer(_MultiDatePicker)
